import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-view',
  templateUrl: './main-view.component.html',
  styleUrls: ['./main-view.component.scss'],
  standalone: false,
})
export class MainViewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
